import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import PageHeader from '../../components/PageHeader';
import SVRForm from '../../components/SVRForm';

export default function SiteVisitReport() {
  const { id } = useParams();
  const navigate = useNavigate();
  return (
    <div>
      <button onClick={() => navigate('/app/estimation/enquiries')} className="flex items-center gap-1.5 text-xs font-display font-bold uppercase tracking-wider text-slate-500 hover:text-[#3b4872] mb-2" data-testid="svr-back-btn">
        <ArrowLeft size={13} /> Back to Enquiry Tracker
      </button>
      <PageHeader overline="Business Development" title="Site Visit Report"
        subtitle="9-section structured report — auto-saves photos, videos, and GPS to object storage. Mandatory before advancing past 'Site Visit' stage." />
      <SVRForm enquiryId={id} onSaved={() => navigate('/app/estimation/enquiries')} />
    </div>
  );
}
